export const MAP_SWITCHERS_PANEL_WIDTH = '240px';
